import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMonthlyStatistics,
  selectMonthlyStatistics
} from "../../redux/statistics/reducer";
import { tt } from "../i18n/i18n";
import { useAccountToDisplaySelector } from "../../redux/actions/user";

const CACHE_DURATION = 60 * 60 * 1000;

export default function useMonthlyStatisticsData() {
  const dispatch = useDispatch();
  const { accountToDisplay } = useAccountToDisplaySelector();
  const monthlyStatistics = useSelector(selectMonthlyStatistics);

  useEffect(() => {
    if (!accountToDisplay?.trackingID || !accountToDisplay?.token) {
      return;
    }

    const shouldFetch =
      !monthlyStatistics.data ||
      !monthlyStatistics.lastFetchedAt ||
      Date.now() - monthlyStatistics.lastFetchedAt > CACHE_DURATION;

    if (shouldFetch && !monthlyStatistics.isLoading) {
      dispatch(fetchMonthlyStatistics() as any);
    }
  }, [
    accountToDisplay?.trackingID,
    accountToDisplay?.token,
    dispatch,
    monthlyStatistics.data,
    monthlyStatistics.lastFetchedAt,
    monthlyStatistics.isLoading
  ]);

  useEffect(() => {
    if (monthlyStatistics.error) {
      console.error(monthlyStatistics.error);
      alert(tt("api_error"));
    }
  }, [monthlyStatistics.error]);

  return {
    sts: monthlyStatistics.data?.sts,
    ets: monthlyStatistics.data?.ets,
    isLoading: monthlyStatistics.isLoading
  };
}
